import { injectIntl } from 'react-intl'
import { Modal, Select } from 'antd'

const StoreModal = props => {
  const { intl, isVisible, onCloseModal, onSelectStore, stores } = props
  return (
    <Modal
      centered
      visible={isVisible}
      title={intl.formatMessage({ id: 'storeModal.title' })}
      footer={false}
      onCancel={onCloseModal}>
      <Select
        showSearch
        optionFilterProp={'children'}
        placeholder={intl.formatMessage({ id: 'storeModal.title' })}
        onChange={onSelectStore}
        size={'large'}
        style={{ width: '100%' }}>
        {stores.map(store => (
          <Select.Option key={store.id}>{store.name}</Select.Option>
        ))}
      </Select>
    </Modal>
  )
}
export default injectIntl(StoreModal)
